import type { BoothSignalSeed } from './booth.schema';

export const BOOTH_VAULT_SIGNAL_SEEDS: readonly BoothSignalSeed[] = [
  {
    seedKey: 'maintenance',
    description:
      'Test for information disclosure of staff identification and internal system architecture in maintenance status response',
    category: 'INFORMATION_DISCLOSURE',
    analysis:
      'Act I: read the homepage source and proxy history, then GET /api/maintenance for the branch-manager breadcrumb.',
  },
  {
    seedKey: 'customer-idor',
    description:
      "Test for IDOR by enumerating customer IDs in /api/customer/{id} endpoint to access other customers' records without authorization",
    category: 'IDOR',
    analysis:
      'Act II: your guest id is 1001; GET /api/customer/1002 to read Dana Vault’s profile and notebook hint.',
  },
  {
    seedKey: 'vault-notes',
    description:
      'Test the token mechanism on /api/admin/vault-notes to identify where the expected authentication token should be provided (Authorization header, additional cookie, query parameter, or custom header).',
    category: 'BROKEN_AUTHENTICATION',
    analysis:
      'Act III: GET /api/token, forge an alg:none admin JWT, GET /api/admin/vault-notes, then unlock via keypad or POST /api/vault/unlock.',
  },
] as const;

export const BOOTH_VAULT_SIGNAL_SEED_DESCRIPTIONS: readonly string[] =
  BOOTH_VAULT_SIGNAL_SEEDS.map((seed) => seed.description);
